<template>
    <div class="view-toggle">
        <div class="options">
            <div
                class="option drift"
                :class="{'selected': $store.state.view === 'operations'}"
                @click="doToggle('operations', operationsLink)"
            >
                {{ operationsName }}
            </div>
            <div
                class="option udvikling"
                :class="{'selected': $store.state.view === 'learning'}"
                @click="doToggle('learning', learningLink)"
            >
                {{ learningName }}
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../styles/vars.scss";

    .view-toggle {
        margin-bottom: $margin--large;
        margin-top: -$margin--main;
        text-align: center;

        .options {
            display: inline-flex;

            .option {
                border-radius: $borderradius--main;
                border: 1px solid rgba(0, 0, 0, 0.15);
                background: $color--white;
                padding: $padding--small $padding--main;
                font-size: $fontsize--sm;
                cursor: pointer;
                transition: $transition--main;

                &:not(:first-of-type) {
                    margin-left: $margin--small;
                }

                &:hover {
                    box-shadow: inset 0 3px 5px rgba(0,0,0,.125);
                }

                &.selected {
                    // background: $color--dark;
                    background: $color--green;
                    color: $color--white;
                    box-shadow: inset 0 3px 5px rgba(0,0,0,.125);
                    // font-weight: $fontweight--bold;

                    &.udvikling {
                        color: $color--white;
                        background: $color--green;
                    }
                }
            }
        }
    }

</style>

<script>
export default {
    props: {
        operationsName: {
            required: true,
            type: String
        },
        operationsLink: {
            required: true,
            type: String
        },
        learningName: {
            required: true,
            type: String
        },
        learningLink: {
            required: true,
            type: String
        }

    },
    methods: {
        doToggle (state, routeName) {
            this.$store.state.view = state
            this.$router.push({name: routeName})
        }
    }
}
</script>



// WEBPACK FOOTER //
// viewToggle.vue?3c0f609a